/** Загрузка и кэширование списка проектов. */
import { useQuery } from "@tanstack/react-query";
import { Api } from "@/api";
import { useAuthStore } from "@/shared/store";
import { projectsKeys } from "./keys";

export const useListProjects = () => {
	const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
	const query = useQuery({
		queryFn: Api.Project.getApiProjects,
		queryKey: projectsKeys.list,
		enabled: isAuthenticated,
	});

	return {
		execute: async () => query.refetch(),
		data: query.data?.data ?? [],
		error: query.data?.error ?? null,
		isPending: query.isPending,
	};
};
